module.exports = __webpack_public_path__ + "static/img/iphone_ldttitle2.5db3cdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_ldttitle2.png
// module id = YIVy
// module chunks = 0